var plus = "https://shopfront-cdn.tekoapis.com/static/f04b3233a3780d10.svg";

export { plus as default };
